import { WORD_DURATION_MS, staggerFor } from '../../components/design-system/chat/revealWordsSchedule';

/** Between two bubbles of one reply: the pause after the first has been read out, before the second appears. */
export const BUBBLE_PAUSE_MS = 700;

/**
 * An Alma reply as the chat bubbles it's shown in: one per paragraph (a blank
 * line in the text). Alma writes her reaction and her next question as separate
 * paragraphs, so they read as two messages, like a person texting. A reply with
 * no blank line stays one bubble.
 */
export function splitBubbles(text: string): string[] {
  const parts = text.split(/\n{2,}/).map((p) => p.trim()).filter(Boolean);
  return parts.length > 0 ? parts : [text];
}

/** How long a reply takes to be fully on screen once it starts: each bubble's words in turn, with a pause between bubbles. */
export function revealDurationMs(text: string): number {
  const bubbles = splitBubbles(text);
  const words = bubbles.map((b) => b.split(/\s+/).filter(Boolean).length);
  const total = words.reduce((sum, n) => sum + n, 0);
  const each = words.reduce((sum, n) => sum + n * staggerFor(total) + WORD_DURATION_MS, 0);
  return Math.round(each + (bubbles.length - 1) * BUBBLE_PAUSE_MS);
}
